import type { JSX } from 'react'
import type {
  ITextBoxMaxLine2HeadlineExtra5,
  ITextBoxMaxLine4Footnote2Props,
} from 'atoms/TextBox/Templates'
import type { ITextBlockProps } from '../../TextBlock'

import {
  TextBoxMaxLine2HeadlineExtra5,
  TextBoxMaxLine4Footnote2,
} from 'atoms/TextBox/Templates'
import { TextBlock } from '../../TextBlock'
import { TextBlockRowGap } from '../../TextBlock.h'

export interface ITextBlockHeadlineExtra5Footnote2Props extends ITextBlockProps {
  title?: ITextBoxMaxLine2HeadlineExtra5['title']
  description?: ITextBoxMaxLine4Footnote2Props['title']
}

export const TextBlockHeadlineExtra5Footnote2 = ({
  title = '',
  description = '',
  rowGap = TextBlockRowGap.INDENT_60,
  ...rest
}: ITextBlockHeadlineExtra5Footnote2Props): JSX.Element => (
  <TextBlock rowGap={rowGap} {...rest}>
    {title && <TextBoxMaxLine2HeadlineExtra5 title={title} />}
    {description && <TextBoxMaxLine4Footnote2 title={description} />}
  </TextBlock>
)
